import { forwardRef, type Ref, type SVGProps } from "react";
const IconKitchenOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M23 4H9a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1M9 2a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3z"
        fill="currentColor"
      />
      <path
        d="M24 15H8v-2h16zM11 7a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1m0 10a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1"
        fill="currentColor"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(IconKitchenOutlineSVG);
ForwardRef.displayName = "IconKitchenOutline";
export { ForwardRef as IconKitchenOutline };
